import { render, staticRenderFns } from "./ExtensionDetails.vue?vue&type=template&id=585e8b67"
import script from "./ExtensionDetails.vue?vue&type=script&lang=ts"
export * from "./ExtensionDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports